import axios from "axios"

let API_NAME = process.env.VUE_APP_API_NAME;

export default {
  
  async getUser(accessToken, id) {
	let res = await axios.get(API_NAME + "/users/" + id, {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
  return res.data;
},

async getMakeupUsers(accessToken) {
	let res = await axios.get(API_NAME + "/users?factory_floor=1", {
		  headers: {
			Authorization: `Bearer ${accessToken}`
		  }
		});
  return res.data;
},
  
}